module.exports = __webpack_public_path__ + "static/media/ddh-logo.34f86036.png";